"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

var _TariffPoint = require("./TariffPoint");

var _TariffPoint2 = _interopRequireDefault(_TariffPoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TariffProductsModel = function (_Observer) {
    _inherits(TariffProductsModel, _Observer);

    /**
     * Liste von Produkten
     * @type {Array} of Products
     */

    /**
     * Tarifpunkt von
     * @type {TariffPoint}
     */
    function TariffProductsModel(observers, id, request) {
        _classCallCheck(this, TariffProductsModel);

        var _this = _possibleConstructorReturn(this, (TariffProductsModel.__proto__ || Object.getPrototypeOf(TariffProductsModel)).call(this, observers, id, request));

        _this.TariffPointFrom = new _TariffPoint2.default();

        _this.TariffPointTo = new _TariffPoint2.default();

        _this.ProductList = [];

        /*this.PriceLevel = "";
        this.Price = 0;
        this.PaymentInterval = "";
        this.ContractEnd = "";
        this.FlagMultiUser = false;
        this.MultiUserCountAdult = 0;
        this.MultiUserCountChild = 0;
        this.RequiredAge = 0;
        this.FixedRoute = false;*/

        _this.SelectedProductId = -1;
        return _this;
    }

    /**
     * index des gewählten Produktes in der Produktliste
     * @type {integer}
     */

    /**
     * Tarifpunkt nach
     * @type {TariffPoint}
     */


    _createClass(TariffProductsModel, [{
        key: "GetSchoolTickets",
        value: function GetSchoolTickets(SchoolId, ContractStart, DateOfBirth, SiblingChildrens) {

            var sendData = {};
            sendData.SchoolId = SchoolId;
            sendData.ContractStart = ContractStart;
            sendData.DateOfBirth = DateOfBirth;
            sendData.SiblingChildrens = SiblingChildrens;

            var me = this;
            this.request.setRequest("/schoolTickets");
            this.request.setType("POST");
            if (this.request.setData) {
                this.request.setData(JSON.stringify(sendData));
            }

            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.ProductList = result.Data.ProductList;
                    }
                }
                var id = me.Id ? me.Id : "SchoolTickets";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: "Clear",
        value: function Clear() {
            this.ProductList = [];
        }
    }, {
        key: "GetTariffProducts",
        value: function GetTariffProducts(From, To, TicketId, DateOfBirth) {
            var me = this;
            if (From !== null && From !== undefined && To !== null && To !== undefined) {
                var sendData = {};
                sendData.TariffPointStart = From;
                sendData.TariffPointDestination = To;

                if (TicketId !== null && TicketId !== undefined) {
                    sendData.TicketId = TicketId;
                }

                if (DateOfBirth !== null && DateOfBirth !== undefined) {
                    sendData.CardHolderDateOfBirth = DateOfBirth;
                } else {
                    sendData.CardHolderDateOfBirth = null;
                }

                this.request.setRequest("/TariffProducts");
                this.request.setType("POST");
                if (this.request.setData) {
                    this.request.setData(JSON.stringify(sendData));
                }
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.ProductList = result.Data.ProductList;
                            me.TariffPointFrom = result.Data.TariffPointFrom;
                            me.TariffPointTo = result.Data.TariffPointTo;
                        }
                    }
                    var id = me.Id ? me.Id : "TariffProducts";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }
    }, {
        key: "GetTariffProductsWithCustomerAbove",
        value: function GetTariffProductsWithCustomerAbove(From, To, TicketId, DateOfBirth, customerAboveId) {
            var me = this;
            if (From !== null && From !== undefined && To !== null && To !== undefined) {
                var sendData = {};
                sendData.TariffPointStart = From;
                sendData.TariffPointDestination = To;

                if (TicketId !== null && TicketId !== undefined) {
                    sendData.TicketId = TicketId;
                }

                if (DateOfBirth !== null && DateOfBirth !== undefined) {
                    sendData.CardHolderDateOfBirth = DateOfBirth;
                } else {
                    sendData.CardHolderDateOfBirth = null;
                }

                this.request.setRequest("/customerAbove/" + customerAboveId + "/tariffProducts");
                this.request.setType("POST");
                if (this.request.setData) {
                    this.request.setData(JSON.stringify(sendData));
                }
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.ProductList = result.Data.ProductList;
                            me.TariffPointFrom = result.Data.TariffPointFrom;
                            me.TariffPointTo = result.Data.TariffPointTo;
                        }
                    }
                    var id = me.Id ? me.Id : "TariffProductsCustomerAbove";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }
    }, {
        key: "GetTickets",
        value: function GetTickets(clientId, contractStart) {
            var me = this;

            if (localStorage.getItem('SelectedProductName') == null || localStorage.getItem('SelectedProductName') == undefined) {

                var sendData = {};

                if (clientId !== null && clientId !== undefined) {
                    sendData.clientId = clientId;
                }

                if (contractStart !== null && contractStart !== undefined) {
                    sendData.contractStart = contractStart;
                }

                this.request.setRequest("/tickets");
                this.request.setType("POST");
                if (this.request.setData) {
                    this.request.setData(JSON.stringify(sendData));
                }
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.ProductList = result.Data.ProductList;
                            me.TariffPointFrom = result.Data.TariffPointFrom;
                            me.TariffPointTo = result.Data.TariffPointTo;

                            localStorage.setItem('TariffProducts', JSON.stringify(result.Data.ProductList));
                        }
                    }
                    var id = me.Id ? me.Id : "Tickets";
                    me.Notify(id);
                });

                this.request.doRequest();
            } else {
                me.ProductList = JSON.parse(localStorage.getItem('TariffProductsTermsOfUsage'));

                var id = me.Id ? me.Id : "Tickets";
                me.Notify(id);
            }
        }
    }, {
        key: "GetTicketsWithBirthDate",
        value: function GetTicketsWithBirthDate(clientId, contractStart, birthDate) {
            var me = this;

            if (localStorage.getItem('SelectedProductName') == null || localStorage.getItem('SelectedProductName') == undefined) {

                if (clientId !== null && clientId !== undefined) {
                    var sendData = {};
                    sendData.clientId = clientId;

                    if (contractStart !== null && contractStart !== undefined) {
                        sendData.contractStart = contractStart;
                    }

                    if (birthDate !== null && birthDate !== undefined) {
                        sendData.cardHolderDateOfBirth = birthDate;
                    }

                    this.request.setRequest("/tickets");
                    this.request.setType("POST");
                    if (this.request.setData) {
                        this.request.setData(JSON.stringify(sendData));
                    }
                    this.request.setCallback(function (result) {
                        if (result) {
                            if (result.Data) {
                                me.ProductList = result.Data.ProductList;
                                me.TariffPointFrom = result.Data.TariffPointFrom;
                                me.TariffPointTo = result.Data.TariffPointTo;

                                localStorage.setItem('TariffProducts', JSON.stringify(result.Data.ProductList));
                            }
                        }
                        var id = me.Id ? me.Id : "Tickets";
                        me.Notify(id);
                    });

                    this.request.doRequest();
                }
            } else {
                me.ProductList = JSON.parse(localStorage.getItem('TariffProductsTermsOfUsage'));

                var id = me.Id ? me.Id : "Tickets";
                me.Notify(id);
            }
        }
    }, {
        key: "GetTicketsWithCustomerAbove",
        value: function GetTicketsWithCustomerAbove(clientId, contractStart, customerAboveId) {
            var me = this;

            if (localStorage.getItem('SelectedProductName') == null || localStorage.getItem('SelectedProductName') == undefined) {

                var sendData = {};

                if (clientId !== null && clientId !== undefined) {

                    sendData.clientId = clientId;
                }

                if (contractStart !== null && contractStart !== undefined) {
                    sendData.contractStart = contractStart;
                }

                this.request.setRequest("/customerAbove/" + customerAboveId + "/tickets");
                this.request.setType("POST");
                if (this.request.setData) {
                    this.request.setData(JSON.stringify(sendData));
                }
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.ProductList = result.Data.ProductList;
                            me.TariffPointFrom = result.Data.TariffPointFrom;
                            me.TariffPointTo = result.Data.TariffPointTo;

                            localStorage.setItem('TariffProducts', JSON.stringify(result.Data.ProductList));
                        }
                    }
                    var id = me.Id ? me.Id : "TicketsCustomerAbove";
                    me.Notify(id);
                });

                this.request.doRequest();
            } else {
                me.ProductList = JSON.parse(localStorage.getItem('TariffProductsTermsOfUsage'));

                var id = me.Id ? me.Id : "TicketsCustomerAbove";
                me.Notify(id);
            }
        }
        /*GetTariffProductsLBV(clientId,tariffPointFrom,tariffPointTo,ticketId){
            let me = this;
            let request = {
                TariffPointStart: tariffPointFrom,
                TariffPointDestination: tariffPointTo,
                TicketId: ticketId
            };
            Request.ajax('json', "application/json;charset=utf-8", true, "/TariffProductsLBV/" + clientId, "POST", JSON.stringify(request), null, null,
            function (result) {
                if(result){
                    if(result.Data){
                        let data = result.Data;
                        if(data.TariffPointFrom){
                            me.TariffPointFrom = data.TariffPointFrom;
                        }
                        if(data.TariffPointTo){
                            me.TariffPointTo = data.TariffPointTo;
                        }
                        if(data.ProductList){
                            me.ProductList = data.ProductList;
                        }
                    }
                }
                let id = me.Id ? me.Id : "TariffProducts";
                me.Notify(id);
            }, null, false);
        }*/

    }]);

    return TariffProductsModel;
}(_Observer3.default);

exports.default = TariffProductsModel;